import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";

const WA_NUMBER = "33672646318";

export default function WhatsAppButton() {
  const [open, setOpen] = useState(false);
  const [popped, setPopped] = useState(false);

  useEffect(() => {
    if (popped) return;
    const t = setTimeout(() => { setOpen(true); setPopped(true); }, 6000);
    return () => clearTimeout(t);
  }, [popped]);

  // No prefilled text — the user writes their own message on WhatsApp.
  const link = `https://wa.me/${WA_NUMBER}`;

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3" data-testid="whatsapp-floating-container">
      {open && (
        <div className="bg-white rounded-2xl shadow-2xl border border-black/5 p-4 w-72 relative" data-testid="whatsapp-popup">
          <button
            onClick={() => setOpen(false)}
            aria-label="Fermer"
            className="absolute top-2 right-2 text-[#5b6577] hover:text-[#1a2332] p-1"
            data-testid="whatsapp-popup-close"
          >
            <X className="w-4 h-4" />
          </button>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#25D366] text-white flex items-center justify-center">
              <MessageCircle className="w-5 h-5" />
            </div>
            <div>
              <div className="font-headings font-bold text-[#1a2332] text-sm">DDSBillancourt</div>
              <div className="text-xs text-[#00a86b]">● En ligne</div>
            </div>
          </div>
          <p className="mt-3 text-sm text-[#1a2332]">
            👋 Bonjour ! Une question sur le permis, le code ou les tarifs ? Discutons sur WhatsApp, on vous répond rapidement.
          </p>
          <a
            href={link}
            target="_blank" rel="noopener noreferrer"
            data-testid="whatsapp-popup-cta"
            className="mt-3 block text-center bg-[#25D366] hover:bg-[#1dab54] text-white font-headings font-bold rounded-xl px-4 py-2.5 text-sm"
          >
            Démarrer la conversation
          </a>
        </div>
      )}
      <a
        href={link}
        target="_blank" rel="noopener noreferrer"
        data-testid="whatsapp-floating-btn"
        aria-label="Contacter sur WhatsApp"
        onClick={() => { setPopped(true); }}
        className="wa-pulse bg-[#25D366] hover:bg-[#1dab54] text-white rounded-full w-14 h-14 flex items-center justify-center shadow-xl hover:scale-110 transition-transform"
      >
        <MessageCircle className="w-7 h-7" />
      </a>
    </div>
  );
}
